import React from "react";
import ButtonForm from "../../ButtonForm/ButtonForm";
import PropTypes from "prop-types";
import "./AccessDetailButton.css";

const AccessDetailButton = ({
  id = "",
  title = "Access Details",
  disabled = false,
  ...rest
}) => {
  return (
    <ButtonForm
      type="button"
      id={id}
      disabled={disabled}
      value={title}
      className="btn-submit"
      {...rest}
    />
  );
};

AccessDetailButton.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default AccessDetailButton;
